import { ListingStatus } from "../../interfaces/listing.interface";

export const STATUS_COLORS: Record<ListingStatus, string> = {
  pending:  "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200",
  active:   "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200",
  rejected: "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200",
  expired:  "bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300",
  draft:    "bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300",
  sold:     "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200",
  hidden:   "bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200",
};

export const LISTING_FORM_TYPE_OPTIONS = [
  { label: "All Types", value: "" },
  { label: "Yacht",               value: "YACHT" },
  { label: "Boat",                value: "BOAT" },
  { label: "Water Toys",          value: "WATER_TOYS" },
  { label: "Engine / Generator",  value: "ENGINE_GENERATOR" },
  { label: "Parts & Accessories", value: "PARTS_ACCESSORIES" },
  { label: "Services",            value: "SERVICES" },
  { label: "Skill Labour",        value: "SKILL_LABOUR" },
  { label: "Charter",             value: "CHARTER" },
];

export const LISTING_STATUS_OPTIONS = [
  { label: "Draft",    value: "draft" },
  { label: "Pending",  value: "pending" },
  { label: "Active",   value: "active" },
  { label: "Rejected", value: "rejected" },
  { label: "Expired",  value: "expired" },
  { label: "Sold",     value: "sold" },
  { label: "Hidden",   value: "hidden" },
];
